import { applicationTypes } from 'constants/scripts';

const managementZones = {
  fill: '#ffffff',
  boundary: '#555555'
};

const COLORS = {
  managementZones,
  unassigned: '#eee',
  zero: '#000',
  null: '#f8f8f8',
  colorBulletNull: {r: 216, g: 216, b: 216},
  scoutingHex: ['#F40000', '#FFF685', '#BEFC98', '#00CB00', '#006400'],
  scouting: [
    {r: 244, g: 0, b: 0},
    {r: 255, g: 246, b: 133},
    {r: 190, g: 252, b: 152},
    {r: 0, g: 203, b: 0},
    {r: 0, g: 100, b: 0}
  ],
  rate: {
    [applicationTypes.FERTILIZER]: ['#930a0c','#f70710','#f7850c','#fbef1c','#9bff0b','#2add08','#1b8718'],
    [applicationTypes.APPLICATION]: ['#930a0c','#f70710','#f7850c','#fbef1c','#9bff0b','#2add08','#1b8718'],
    [applicationTypes.SEED]: ['#930a0c','#f70710','#f7850c','#fbef1c','#9bff0b','#2add08','#1b8718']
  },
  soil: [
    '#800000',
    '#008000',
    '#000080',
    '#808000',
    '#800080',
    '#008080',
    '#9999FF',
    '#993366',
    '#FFFFCC',
    '#CCFFFF',
    '#660066',
    '#FF8080',
    '#0066CC',
    '#CCCCFF',
    '#FF0000',
    '#00FF00',
    '#0000FF',
    '#FFFF00',
    '#FF00FF',
    '#00FFFF'
  ],
  vegetation: [
    {r: 66, g: 70, b: 107},
    {r: 2, g: 72, b: 3},
    {r: 21, g: 124, b: 8},
    {r: 36, g: 162, b: 14},
    {r: 52, g: 203, b: 20},
    {r: 119, g: 219, b: 14},
    {r: 194, g: 233, b: 6},
    {r: 252, g: 244, b: 0},
    {r: 188, g: 133, b: 46},
    {r: 176, g: 177, b: 184}
  ],
  scenarios: {
    newPlan: '#153063',
    recommendation: '#6CCCDD',
    bulkScriptRecommendation: '#F6B552',
    'zone-1': '#C70000',
    'zone-2': '#65CE24',
    'zone-3': '#F6B552',
    'zone-4': '#FCE516',
    'zone-5': '#990404',
    'zone-6': '#14A352',
    'zone-7': '#007AFF',
    'zone-8': '#774812',
    'zone-9': '#EB7180',
    'zone-10': '#B6F58F',
    'zone-11': '#7FBCFF',
    'zone-12': '#808080',
    'newPlan-bullet': { r: 21, g: 48, b: 99 },
    'recommendation-bullet': { r: 108, g: 204, b: 221 },
    'zone-1-bullet': { r: 199, g: 0, b: 0 },
    'zone-2-bullet': { r: 101, g: 206, b: 36 },
    'zone-3-bullet': { r: 246, g: 181, b: 82 },
    'zone-4-bullet': { r: 252, g: 229, b: 22 },
    'zone-5-bullet': { r: 153, g: 4, b: 4 },
    'zone-6-bullet': { r: 20, g: 163, b: 82 },
    'zone-7-bullet': { r: 0, g: 122, b: 255 },
    'zone-8-bullet': { r: 119, g: 72, b: 18 },
    'zone-9-bullet': { r: 235, g: 113, b: 128 },
    'zone-10-bullet': { r: 182, g: 245, b: 143 },
    'zone-11-bullet': { r: 127, g: 188, b: 255 },
    'zone-12-bullet': { r: 128, g: 128, b: 128 },
  },
  productivity: ['#1D8718', '#29DD06', '#FBEF1B', '#F7850A', '#F70711', '#000000']
};

export default COLORS;
